import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { UserService } from "src/app/services/user.service";
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-auditoria-operadora',
  templateUrl: './auditoria-operadora.component.html',
  styleUrls: ['./auditoria-operadora.component.scss']
})
export class AuditoriaOperadoraComponent implements OnInit {

public nome: string;
  public arrayTurma: any;
  public turmaSelecionada: any;

  constructor(
    private router: Router,
    private ajax: AjaxService,
    public util: UtilService,
    private auth: UserService
  ) { }

  ngOnInit() {
    this.buscar();
  }

  carregarEdicao(item) {
    this.router.navigate(['/cronograma-a-fazer']);
    /*console.log(item);
    this.limpar();
    this.turmaSelecionada = item;
    this.nome = item.descricao;*/
  }

  buscar() {
    this.util.showLoading();
    //let url = API + "Turma/Turma";
    let url =  "fake-data/auditoria.json";
    return this.ajax.get(url).subscribe(
      (response) => {
        this.arrayTurma = response.data;
        console.log(this.arrayTurma);
        this.util.closeLoading();
      },
      (err) => {
        ;
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Buscar Turma");
      }
    );
  }

  valida() {
    if (this.nome == undefined || this.nome == "") {
      this.util.toasterShowError("Atenção", "Entre com o Nome do Turma");
      return false;
    }

    return true;
  }

  limpar() {
    this.nome = "";
    this.turmaSelecionada = null;
  }

  salvar() {
    /*if (this.valida()) {
      ;
      let dados = {
        descricao: this.nome,
        STATUS: true,
      };

      if(this.turmaSelecionada != null)
        dados['ID_TURMA'] = this.turmaSelecionada.iD_TURMA;

      let url = API + "Turma/Turma";
      return this.ajax.post(url, dados).subscribe(
        (response) => {
          this.util.closeLoading();
          this.util.toasterShowSuccess("Atenção", "Turma Salvo com Sucesso");
          this.limpar();
          this.buscar();
        },
        (err) => {
          ;
          this.util.closeLoading();
          this.util.toasterShowError("Atenção", "Erro ao Salvar Turma");
        }
      );
    }*/
  }

  desabilitar(id: string) {

    this.router.navigate(['/cronograma']);
    /*;
    let dados = {
      id: id,
    };
    let url = API + "Turma/Turma/Desabilitar/" + id;
    return this.ajax.post(url, dados).subscribe(
      (response) => {
        this.util.closeLoading();
        this.util.toasterShowSuccess(
          "Atenção",
          "Turma Desabilitado com Sucesso"
        );
        this.nome = "";
        this.buscar();
      },
      (err) => {
        ;
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Salvar Turma");
      }
    );*/
  }
}
